const SiteWideHeader = require('./modules/site-wide-header.js');
new SiteWideHeader();


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[target="_blank"]').forEach((element) => {
    const ariaLabel = element.getAttribute('aria-label');
    if (ariaLabel) {
      element.setAttribute('aria-label', `Opens in a new window ${ariaLabel}`);
    } else {
      element.setAttribute('aria-label', `Opens in a new window ${element.textContent}`)
    }
  });

  document.querySelectorAll('a').forEach((element) => {
    const hasLink = element.getAttribute('href');
    if (hasLink && hasLink.indexOf(".pdf") != -1) {
      element.setAttribute('data-has-pdf', 'true');
      element.setAttribute('aria-label', `${element.textContent} - Opens a pdf file`);
    }
  });
});